import log from 'loglevel'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { SurveyResponseData } from '../api/models/ResponseData'
import { SurveyDetailItem } from '../api/models/SurveyDetailItem'
import { listResponses } from '../api/responsesApi'
import { fetchSurveyById } from '../api/surveyApi'
import { Box } from '../components/Box'
import { ButtonState } from '../components/Button'
import { Spinner } from '../components/icons/Spinner'
import { SettingsPanel } from '../components/SettingsPanel'

export function Responses() {
  const history = useHistory()
  const { surveyId } = useParams<{ surveyId: string }>()
  const [loadingResponses, setLoadingResponses] = React.useState<ButtonState>(
    'pending'
  )
  const [
    surveyResponseData,
    setSurveyResponseData,
  ] = React.useState<SurveyResponseData>({
    responses: [],
    surveyUrl: surveyId,
  })
  const [
    loadingSurveyStatus,
    setLoadingSurveyStatus,
  ] = React.useState<ButtonState>('idle')
  const [surveyItem, setSurveyItem] = React.useState<
    SurveyDetailItem | undefined
  >(undefined)

  // React.useEffect(() => {
  //   if (!sessionInfo) return
  //   ;(async () => {
  //     if (!sessionInfo.webId) {
  //       log.debug('no webid on session found')
  //       return
  //     }
  //     setLoadingSurveyStatus('pending')
  //     const profileDataset = await getSolidDatasetWithAcl(sessionInfo.webId, {
  //       fetch: fetchByServer,
  //     })
  //     const profileThing = getThing(profileDataset, sessionInfo.webId)
  //     if (!profileThing) {
  //       log.debug('Could not fetch profileThing from profileDataset')
  //       return
  //     }
  //     const podUrls = getUrlAll(
  //       profileThing,
  //       'http://www.w3.org/ns/pim/space#storage'
  //     )
  //     const pod = podUrls[0]
  //     const containerUri = `${pod}survey/`
  //     const fileName = `survey-${surveyId}.ttl`
  //     const indexUrl = `${containerUri}${fileName}`
  //     const surveyDataset = await getSolidDataset(indexUrl, {
  //       fetch: fetchByServer,
  //     })
  //
  //     setSurveyUrl(`${containerUri}${fileName}`)
  //     setContainerUri(containerUri)
  //     setFileName(fileName)
  //     setDataset(surveyDataset)
  //     setLoadingSurveyStatus('resolved')
  //   })()
  // }, [sessionInfo])

  React.useEffect(() => {
    setLoadingResponses('pending')
    listResponses(surveyId).then(
      res => {
        setSurveyResponseData(res)
        setLoadingResponses('resolved')
      },
      err => {
        log.error({ err })
        setLoadingResponses('rejected')
      }
    )
  }, [surveyId])

  React.useEffect(() => {
    setLoadingSurveyStatus('pending')
    fetchSurveyById(surveyId).then(
      item => {
        setSurveyItem(item)
        setLoadingSurveyStatus('resolved')
      },
      e => {
        log.error({ err: e })
        setLoadingSurveyStatus('rejected')
      }
    )
  }, [surveyId])

  function getQuestionByUrl(url: string | undefined): string {
    if (!surveyItem) {
      return ''
    }
    const question = surveyItem.questions.find(q => q.url === url)
    return question ? question.text : url || ''
  }

  return (
    <>
      <SettingsPanel className="mb-8">
        {loadingResponses === 'pending' ? (
          <div className="px-4 py-5 sm:px-6 flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div className="px-4 py-5 sm:px-6 flex flex-row items-center">
            <div className="text-gray-500 text-sm">
              <strong>{surveyResponseData.responses.length}</strong>{' '}
              {surveyResponseData.responses.length === 1
                ? 'response '
                : 'responses '}
              <span>
                for survey <strong>{surveyId}</strong>
              </span>
            </div>
          </div>
        )}
      </SettingsPanel>

      <div className="mb-8">
        <a
          onClick={() => history.push('/surveys')}
          className="text-sm text-gray-400 sm:px-6 px-4 cursor-pointer"
        >
          &lt; Go back
        </a>
      </div>

      <Box>
        <div className="overflow-x-auto">
          <table className="min-w-max w-full table-auto">
            <thead>
              <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                <th className="py-3 px-6 text-left">Responses</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {loadingResponses === 'pending' ? (
                <tr className="">
                  <td
                    colSpan={1}
                    className="py-3 px-6 text-center whitespace-nowrap"
                  >
                    <div className="flex justify-center">
                      <Spinner />
                    </div>
                  </td>
                </tr>
              ) : null}
              {loadingResponses === 'resolved' &&
              surveyResponseData.responses.length === 0 ? (
                <tr className="">
                  <td
                    colSpan={1}
                    className="py-3 px-6 text-center whitespace-nowrap"
                  >
                    No responses found.{' '}
                  </td>
                </tr>
              ) : null}
              {loadingResponses === 'rejected' ? (
                <tr className="">
                  <td
                    colSpan={1}
                    className="py-3 px-6 text-center whitespace-nowrap"
                  >
                    Error: Could not load responses
                  </td>
                </tr>
              ) : null}
              {loadingResponses === 'resolved' &&
                surveyResponseData.responses.map((r, i) => (
                  <tr
                    key={i}
                    className="border-b border-gray-200 hover:bg-gray-100"
                  >
                    <td className="py-3 px-6 text-left whitespace-nowrap">
                      {r.completedQuestions.map(c => (
                        <div key={c.url}>
                          <div className="">
                            {getQuestionByUrl(c.completesQuestion)}
                          </div>
                          <div className="font-medium mb-2">{c.answerText}</div>
                        </div>
                      ))}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Box>
    </>
  )
}
